<template>
  <div class="b-datepicker">
    <a-date-picker
      v-model="selectedDate"
      :locale="locale"
      :format="format"
      :inputReadOnly="inputReadonly"
      :placeholder="placeholder"
      :autoFocus="autoFocus"
      :disabled="disabled"
      :disabledDate="checkDisabledDate"
      :allowClear="clearable"
      :dropdownClassName="dropdownClass"
      @focus="onFocusInput"
      @change="handleOnChange"
      @panelChange="handlePanelChange"
      @blur="handleBlur"
    >
      <!-- <template slot="dateRender" slot-scope="current, today">
        <div class="highlight">
          {{m(today).date()}}
        </div>
      </template> -->
    </a-date-picker>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/ja_JP'
import moment from 'moment'

export default {
  name: 'DatePicker',
  components: {},
  props: {
    value: {
      type: [String, Object],
      default: ''
    },
    mode: {
      type: String,
      default: 'date'
    },
    format: {
      type: String,
      default: 'YYYY/MM/DD'
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false
      }
    },
    minDate: {
      type: [String, Object]
    },
    maxDate: {
      type: [String, Object]
    },
    placeholder: {
      type: String,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    iconPosition: {
      type: String,
      default: 'tail'
    },
    showToday: {
      type: Boolean,
      default: false
    },
    dropdownClassName: {
      type: String
    }
  },
  data() {
    return {
      locale,
      inputReadonly: true,
      triangleMarks: [],
      timeMarks: [],
      screenDates: [],
      isChangeDisplayDate: false,
      currentDisplayDate: undefined,
      currentMode: this.mode
    }
  },
  mounted() {
    if (this.options) {
      Object.keys(this.options).forEach((key) => {
        this[key] = this.options[key]
      })
    }

    if (this.value) {
      this.currentDisplayDate = moment(this.value)
    }
  },
  methods: {
    m(date) {
      return moment(date)
    },
    handleOnChange($event) {
      this.$emit('change', $event)
    },
    handleBlur() {
      this.currentMode = this.mode ? this.mode : 'date'
    },
    handlePanelChange(value, mode) {
      this.currentMode = mode
      if (mode === 'month') {
        this.handleMonthMode()
      } else if (mode === 'year') {
        this.handleYearMode()
      } else {
        this.currentDisplayDate = moment(value)
      }
      this.onFocusInput()
    },
    onFocusInput() {
      setTimeout(() => {
        // Month
        if ($('.ant-calendar-prev-month-btn').length) {
          const nextIconEl = $($('.ant-calendar-prev-month-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handlePrevMonth()
          })
        }
        if ($('.ant-calendar-next-month-btn').length) {
          const nextIconEl = $($('.ant-calendar-next-month-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handleNextMonth()
          })
        }
        // year
        if ($('.ant-calendar-prev-year-btn').length) {
          const nextIconEl = $($('.ant-calendar-prev-year-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handlePrevYear()
          })
        }
        if ($('.ant-calendar-next-year-btn').length) {
          const nextIconEl = $($('.ant-calendar-next-year-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handleNextYear()
          })
        }
      }, 500)
    },
    handleMonthMode() {
      setTimeout(() => {
        // ant-calendar-month-panel-prev-year-btn
        if ($('.ant-calendar-month-panel-prev-year-btn').length) {
          const nextIconEl = $($('.ant-calendar-month-panel-prev-year-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handlePrevYear()
          })
        }

        // ant-calendar-month-panel-next-year-btn
        if ($('.ant-calendar-month-panel-next-year-btn').length) {
          const nextIconEl = $($('.ant-calendar-month-panel-next-year-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handleNextYear()
          })
        }
      }, 500)
    },

    registerYearEvents() {
      setTimeout(() => {
        const yearElLength = $('.ant-calendar-year-panel-cell').length
        if (yearElLength) {
          const firstYearEl = $($('.ant-calendar-year-panel-cell')[0])
          const lastYearEl = $($('.ant-calendar-year-panel-cell')[yearElLength - 1])
          firstYearEl.off('click').on('click', () => {
            this.handlePrevDecade()
            this.registerYearEvents()
          })

          lastYearEl.off('click').on('click', () => {
            this.handleNextDecade()
            this.registerYearEvents()
          })
        }
      }, 100)
    },

    handleYearMode() {
      setTimeout(() => {
        // ant-calendar-year-panel-prev-decade-btn
        if ($('.ant-calendar-year-panel-prev-decade-btn').length) {
          const nextIconEl = $($('.ant-calendar-year-panel-prev-decade-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handlePrevDecade()
            this.registerYearEvents()
          })
        }

        // ant-calendar-year-panel-next-decade-btn
        if ($('.ant-calendar-year-panel-next-decade-btn').length) {
          const nextIconEl = $($('.ant-calendar-year-panel-next-decade-btn')[0])
          nextIconEl.off('click').on('click', () => {
            this.handleNextDecade()
            this.registerYearEvents()
          })
        }
      }, 500)
      this.registerYearEvents()
    },
    handlePrevMonth() {
      this.currentDisplayDate.subtract(1, 'months')
      this.isChangeDisplayDate = !this.isChangeDisplayDate
    },
    handleNextMonth() {
      this.currentDisplayDate.add(1, 'months')
      this.isChangeDisplayDate = !this.isChangeDisplayDate
    },
    handlePrevYear() {
      this.currentDisplayDate.subtract(1, 'years')
      this.isChangeDisplayDate = !this.isChangeDisplayDate
    },
    handleNextYear() {
      this.currentDisplayDate.add(1, 'years')
      this.isChangeDisplayDate = !this.isChangeDisplayDate
    },
    handlePrevDecade() {
      this.currentDisplayDate.subtract(10, 'years')
      this.isChangeDisplayDate = !this.isChangeDisplayDate
    },
    handleNextDecade() {
      this.currentDisplayDate.add(10, 'years')
      this.isChangeDisplayDate = !this.isChangeDisplayDate
    },
    checkDisabledDate($event) {
      if (this.currentMode === 'year') {
        const minYear = this.minDate ? this.minDate.year() : 0
        const maxYear = this.maxDate ? this.maxDate.year() : 9999
        const currentYear = $event ? $event.year() : 0
        return currentYear > maxYear || currentYear < minYear
      }

      // check minDate/maxDate
      if (
        this.minDate &&
        ($event.isBefore(this.minDate, 'day') || $event.isBefore(this.minDate, 'month'))
      ) {
        return true
      }

      if (this.maxDate && $event.isAfter(this.maxDate)) {
        return true
      }

      return this.disabledDate($event)
    }
  },
  computed: {
    selectedDate: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    dropdownClass() {
      let className = 'datepicker-dropdown'
      if (this.isChangeDisplayDate || !this.isChangeDisplayDate) {
        // check disabled prev/next month buttons
        if (
          this.minDate &&
          this.currentDisplayDate &&
          this.currentDisplayDate.isSameOrBefore(moment(this.minDate), 'month')
        ) {
          className += ' disabled-prev-month-btn'
        }
        if (
          this.maxDate &&
          this.currentDisplayDate &&
          this.currentDisplayDate.isSameOrAfter(moment(this.maxDate), 'month')
        ) {
          className += ' disabled-next-month-btn'
        }
        // check disabled prev/next year buttons
        const minYear = moment(this.minDate).year()
        const minMonth = moment(this.minDate).month()
        const currentDisplayYear = moment(this.currentDisplayDate).year()
        const currentDisplayMonth = moment(this.currentDisplayDate).month()
        const subtractYear = currentDisplayYear - minYear
        const subtractMonth = currentDisplayMonth - minMonth
        let disablePrevYear = false
        if (subtractYear === 1) {
          if (subtractMonth < 0) {
            disablePrevYear = true
          }
        }
        if (
          (this.minDate &&
            this.currentDisplayDate &&
            this.currentDisplayDate.isSameOrBefore(moment(this.minDate), 'year')) ||
          disablePrevYear
        ) {
          className += ' disabled-prev-year-btn'
        }
        if (
          this.maxDate &&
          this.currentDisplayDate &&
          this.currentDisplayDate.isSameOrAfter(moment(this.maxDate), 'year')
        ) {
          className += ' disabled-next-year-btn'
        }

        // check disabled prev/next decade buttons
        if (
          this.minDate &&
          this.currentDisplayDate &&
          this.currentDisplayDate.isSameOrBefore(moment(this.minDate), 'year')
        ) {
          className += ' disabled-prev-decade-btn'
        }
        if (
          this.maxDate &&
          this.currentDisplayDate &&
          this.currentDisplayDate.isSameOrAfter(moment(this.maxDate), 'year')
        ) {
          className += ' disabled-next-decade-btn'
        }
      }

      if (this.dropdownClassName) {
        className += ` ${this.dropdownClassName}`
      }
      return className
    }
  },
  watch: {
    selectedDate(value) {
      this.currentDisplayDate = moment(value)
    },
    currentDisplayDate: {
      deep: true,
      handler() {
        this.isChangeDisplayDate = !this.isChangeDisplayDate
      }
    }
  }
}
</script>

<style scoped>
:deep() .n-date-panel-date::before {
  content: '○';
  color: #0d76bf;
  font-size: 18px;
  position: absolute;
  right: -8px;
  bottom: -10px;
}
</style>
